import Link from "next/link"
import React from "react"
import useT from "utils/useT"

const SuccessModal = () => {
  const t = useT()
  return (
    <div className="boxed-text-xl py-2 pb-4">
      <div className="text-center mt-4">
        <i className="fa fa-3x fa-check-circle color-green-dark" />
      </div>
      <h4 dir="auto" className="text-center mt-4 mb-2">
        {t.submit.success}
      </h4>
      <Link href="/" className="bg-green-light btn rounded mt-4 px-4">
        {t.navBar.home}
      </Link>
    </div>
  )
}

export default SuccessModal
